import aquarium from './aquarium.JPG'
import cape from './cape-reinga.jpg';
import corn from './corn.jpg';
import cuddle from './cuddle.JPEG'
import engaged from './engaged.JPEG'
import graduation from './graduation.JPEG'
import ring from './may_ring.JPEG'
import soup from './soup-sandos.jpg';
import wine from './wine-cheers.jpg';

const galleryImages = [
    aquarium, 
    cape, 
    corn, 
    cuddle, 
    engaged, 
    graduation,
    ring, 
    soup, 
    wine
];

export default galleryImages;